import { render, staticRenderFns } from "./CouponOverview.vue?vue&type=template&id=4df4d8ed&scoped=true"
import script from "./CouponOverview.vue?vue&type=script&lang=js"
export * from "./CouponOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df4d8ed",
  null
  
)

export default component.exports